import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ColumnNamesUtilityService {
    public constructor() { }

    public getTransactionColumnName() : Array<object> {
        const column = [
            { field: 'partnerId', header: 'Partner ID' },
            { field: 'pac', header: 'PAC' },
            { field: 'logEventType', header: 'Event Type' },
            { field: 'logEventAction', header: 'Action' },
            { field: 'status', header: 'Status' },
            { field: 'logEventDate', header: 'Date / Time (UTC)' },
            { field: 'logEventId', header: 'Test Activation / Contract ID' }

        ];
        return column;
    }

    public getConfigurationColumnName() : Array<object> {
        const column = [
            { field: 'logEventId', header: 'Configuration ID' },
            { field: 'logEventDescription', header: 'Event Description' },
            { field: 'logEventType', header: 'Event Type' },
            { field: 'logEventAction', header: 'Action' },
            { field: 'status', header: 'Status' },
            { field: 'logEventDate', header: 'Date / Time (UTC)' },
            { field: 'logEventBy', header: 'Last Updateby' }
        ];
        return column;
    }

    public getTransactionStatus() : Array<object> {
        const status = [
            { name: 'Pass', value: 'pass' },
            { name: 'Fail', value: 'fail' }
        ];
        return status;
    }
}
